import React from "react";
import {
  Box,
  Dialog,
  DialogContent,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CommonButton from "components/commonButton/CommonButton";

function CommonConfirmModel(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const handleClose = () => {
    props.handleClose();
  };

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={props.open || false}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="customDialog"
      >
        <Box id="responsive-dialog-title" className="mt20"></Box>

        <DialogContent className="p0">
          <Grid item container md={12} className="justifyCenter">
            <Grid item className="textCenter">
              <Typography
                variant="head5"
                className="fw600 colorPrimary justifyCenter"
              >
                Confirm
              </Typography>
              <Typography variant="body2">
                You have selected {props?.totalInvoice} {parseFloat(props?.totalInvoice) === 1 ? "invoice" : "invoices"} for approval.
              </Typography>
              <Typography variant="body2"> 
                Are you sure want to confirm?
              </Typography>
            </Grid>
          </Grid>
          <Grid container className="justifyArround borderTop mt30">
            <Grid item md={6} className="cancelBtn borderRight">
              <CommonButton
                name={"Cancel"}
                type="submit"
                btnClass="btnMd btnCancel"
                onClick={props?.handleCancel}
              />
            </Grid>
            {/* <div className="borderRight"></div> */}
            <Grid item md={6} className="okayBtn">
              <CommonButton
                name={"Okay"}
                type="submit"
                btnClass="btnMd btnOkay"
                onClick={props?.confirmApproval}
              />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default CommonConfirmModel;
